<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3 is-flex-vcenter">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-tabela-preco') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-column">
                <div class="column">
                    <vs-select
                        :id="generateId(2)"
                        ref="clienteInput"
                        :title="'cliente'"
                        :options="cliente"
                        v-model="clienteTabPreco.idCliente"
                        :search="loadCliente"
                        :onChange="updateCliente"
                        :placeholder="'cliente'"
                        :invalid="isNull(clienteTabPreco.idCliente)"
                        :loading="loadingCliente"
                    />
                </div>
                <div class="column">
                    <vs-select
                        :id="generateId(1)"
                        ref="tabPrecoInput"
                        :title="'tab-preco'"
                        :options="tabsPreco"
                        v-model="clienteTabPreco.idTabPreco"
                        :search="loadTabPreco"
                        :onChange="updateTabPreco"
                        :placeholder="'tab-preco'"
                        :invalid="isNull(clienteTabPreco.idTabPreco)"
                        :loading="loadingTabPreco"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";

// MENSAGENS
import Message from "@/models/Message";

// UTILS
import AssClienteTabPrecoB2BEmpresaService from '@/services/b2b/AssClienteTabPrecoB2BEmpresaService';
import ClienteTabPrecoB2BEmpresaValidation from "@/services/validations/b2b/ClienteTabPrecoB2BEmpresaValidation";
import { cpfcnpj } from "@/functions/masks";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            tabsPreco:[],
            cliente:[],
            loadingTabPreco: false,
            loadingCliente: false,
            clienteTabPreco: {
                idCliente: null,
                idTabPreco: null
            },
            service: new TabPrecoService(this.$http, this.$router),
            clienteService: new AssClienteTabPrecoB2BEmpresaService(this.$http, this.$router),
            idproduto: 0,
            isLoading: false,
            validate: null,
            msgs: [],
        }
    },
    created() {
        this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.validation = new ClienteTabPrecoB2BEmpresaValidation(this.msgs);
        
            this.loadTabPreco()
            this.loadCliente()
        },
        save() {
            const lotTemp = this.mapOnSave(this.clienteTabPreco)
            if (this.validation.validate(lotTemp, this.$refs)) {
                this.isLoading = true;
                this.clienteService
                .save(lotTemp)
                .then(value => {
                    if (!value.content) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(_ => {
                    this.isLoading = false;
                });
            }
        },
        loadTabPreco() {
            this.loadingTabPreco = true;
            this.service
                .findAllComboTabPreco()
                .then(this.mapTabsPreco)
                .then((value) => {
                    this.tabsPreco = value;
                })
                .catch(e => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(_ => {
                    this.loadingTabPreco = false;
                });
        },
        loadCliente(searchQuery) {
            this.loadingCliente = true;
            this.clienteService
                .findAllCombo(this.$route.params.id, searchQuery)
                .then(this.mapCliente)
                .then((value) => {
                    this.cliente = value;
                })
                .catch((e) => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.loadingCliente = false;
                });
        },
        updateTabPreco(idTabPreco) {
            if (idTabPreco) {
                this.clienteTabPreco.idTabPreco = idTabPreco;
            } else {
                this.clienteTabPreco.idTabPreco = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateCliente(empresa) {
            if (empresa) {
                this.clienteTabPreco.idCliente = empresa;
            } else {
                this.clienteTabPreco.idCliente = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        mapTabsPreco(item) {
            return item.content.map(m => {
                return {
                    id: m.idtabpreco,
                    descricao: m.descricao,
                    label: m.descricao
                };
            });
        },
        mapCliente(item){
            return item.content.map(({ idCliente, cnpjCpf, rsocial, nome, cidade, estado }) => {
                const nomeFormatado = `${cnpjCpf ? cpfcnpj(cnpjCpf) : 'Não informado'} - ${rsocial ? rsocial : nome} - ${cidade ? cidade : 'Não informado'}${estado ? `-${estado}` : ''}`
                
                return {
                    id: idCliente,
                    descricao: nomeFormatado,
                    label: nomeFormatado
                }
            })
        },
        mapOnSave(item){
            return {
                idEmpresa: this.$route.params.id,
                idCliente: item.idCliente.id,
                idTabPreco: item.idTabPreco.id
            };
        },
        generateId(numberId){
            return this.$route.name+'-b2b-'+numberId;
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
.bg > #main {
    padding: 20px 20px;
}
</style>